<template>
    <div class="home-page">
      <h1>
        <font-awesome-icon :icon="['fas', 'hand-wave']" />
        Welcome back!
      </h1>
      <div class="quick-links">
          <router-link to="/list/" class="button back">
            Open my Dishlist
          </router-link>
          <router-link to="/report/" class="button back">
            Create a Report
          </router-link>
      </div>
      <h2>
        <font-awesome-icon :icon="['fas', 'circle-check']" />
        Your progress this week
      </h2>
      <div class="weekly-progress-checker">
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>MON</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>TUS</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>WED</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>THU</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>FRI</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>SAT</p>
        </div>
        <div class="weekly-progress-item">
          <font-awesome-icon class="fa-xl" :icon="['fas', 'circle-check']" />
          <p>SUN</p>
        </div>
      </div>
      <h2>
        <font-awesome-icon :icon="['fas', 'bowl-food']" />
        Dishes you haven't tried in a while
      </h2>
      <div class="recommendations-list">
        <div class="recommendation-item">
          <img src="@/assets/images/placeholder.png" alt="Dish Placeholder" />
          <p>Dish Name</p>
        </div>
        <div class="recommendation-item">
          <img src="@/assets/images/placeholder.png" alt="Dish Placeholder" />
          <p>Dish Name</p>
        </div>
        <div class="recommendation-item">
          <img src="@/assets/images/placeholder.png" alt="Dish Placeholder" />
          <p>Dish Name</p>
        </div>
      </div>
    </div>
</template>

<style lang="css" scoped>

.weekly-progress-checker {
  width: 100%;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
}

.weekly-progress-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.recommendations-list {
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: scroll;
}

.recommendation-item {
  width: 33%;
  min-width: 33%;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.recommendation-item > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.quick-links {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

</style>
  